import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import AurTooltip from '../../../../common/aur-tooltip/AurTooltip';
import {ReactComponent as InfoIcon} from '../../../../../assests/svg/info_icon_outlined_blue.svg';

const TermsContentHeader = () => {
  return (
    <Box className="terms-content-header">
      <div className="terms-content-header-title">
        <Typography className="typo-text headline3_size" component="h2">
          {t('eca.searchTermReport.termsContent.heading')}
        </Typography>
        <AurTooltip
          title={t('eca.searchTermReport.termsContent.tooltip')}
          aria-label={t('eca.searchTermReport.termsContent.tooltip')}
          className="typo-text label3_size terms-tooltip-content"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -10],
                  },
                },
              ],
            },
          }}
        >
          <InfoIcon aria-hidden="true" focusable="false" className="terms-content-header-title-icon" />
        </AurTooltip>
      </div>
      <div className="terms-content-header-body">
        <Typography className="typo-text body3_size">
          {t('eca.searchTermReport.termsContent.subHeading')}
        </Typography>
      </div>
    </Box>
  );
};

export default TermsContentHeader;
